import React, { Component } from 'react'

export default class LoadMoreNextWeek extends Component {
    render() {
        return <button type="button" className="c-btn c-btn--red c-btn--small" onClick={this.onClick}>See next week</button>
    }

    onClick() {
        // Watch the outer container for DOM changes
        const container = document.querySelector('.c-app-whats-on');

        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                // Check the first node added by this mutation
                const added = mutation.addedNodes[0];
                // Ensure it's an element node before querying (nodeType 1 = Element)
                if (added && added.nodeType === 1) {
                    // Find the first event link within the newly added content
                    const el = added.querySelector('.c-day-event__link');
                    if (el) {
                        el.focus();
                        // Stop observing once we've found and focused the target
                        observer.disconnect();
                        return;
                    }
                }
            }
        });

        // Start observing before dispatching, so we don't miss the update
        observer.observe(container, { childList: true, subtree: true });
        window.dispatchEvent(new CustomEvent("whatson:load-more"));
    }
}



// WEBPACK FOOTER //
// ./src/whatson/components/LoadMoreNextWeek.js